import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { RestService } from '../../../../services/rest/rest.service';
import { Account } from '../../../../domain/account.domain';

export class NicknameMap {
  [key: string]: string
}

@Injectable({
  providedIn: 'root'
})
export class RenameAccountsService {
  private readonly restService = inject(RestService);

  /**
   * getNicknameByGroupIdMap
   * Creates a mapping object by groupId as keys and nicknames for values
   */
  getNicknameByGroupIdMap(accounts: Array<Account>): NicknameMap {
    const nicknameMap: NicknameMap = {};
    accounts.forEach((item: Account) => {
      nicknameMap[item.groupId] = this.getNicknameOrEmpty(item);
    });
    return nicknameMap;
  }

  /**
   * updateNicknames
   * Retrieves changed accounts into array and calls POST API
   *
   * @params accounts: Array of objects to update
   * @params nickNameByGroupId: Map of account nicknames
   * @return POST Promise
   */
  async updateNicknames(accounts: Array<Account>, nickNameByGroupId: NicknameMap): Promise<unknown> {
    const updateNickNames: Array<{ groupId: string, nickName: string }> = [];
    accounts.forEach((account: Account): void => {
      const nickName = nickNameByGroupId[account.groupId];
      if (nickName !== this.getNicknameOrEmpty(account)) {
        updateNickNames.push({
          groupId: account.groupId,
          nickName: account.nickName
        });
      }
    });

    const res = await lastValueFrom<{ data: unknown}>(this.restService
      .getResource('account_v2.updateAccountsNickNames')
      .post({ updateNickNames }));
    return res.data;
  }

  /**
   * getNicknameOrEmpty
   * converts undefined or null to empty string,
   * so we don't enable button when user clears an uncommitted change
   *
   * @param account
   */
  getNicknameOrEmpty(account: Account): string {
    return account.nickName === undefined  || account.nickName === null ?  '' : account.nickName ;
  }
}

